import { render } from "./Itinerary.vue?vue&type=template&id=0b9e10fb&scoped=true"
import script from "./Itinerary.vue?vue&type=script&lang=js"
export * from "./Itinerary.vue?vue&type=script&lang=js"

import "./Itinerary.vue?vue&type=style&index=0&id=0b9e10fb&scoped=true&lang=css"

import exportComponent from "/home/runner/work/projeto_logistica/projeto_logistica/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b9e10fb"],['__file',"src/views/Itineraries/Itinerary.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0b9e10fb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0b9e10fb', __exports__)) {
    console.log('reload')
    api.reload('0b9e10fb', __exports__)
  }
  
  module.hot.accept("./Itinerary.vue?vue&type=template&id=0b9e10fb&scoped=true", () => {
    console.log('re-render')
    api.rerender('0b9e10fb', render)
  })

}


export default __exports__